// extracted by mini-css-extract-plugin
export default {"decorativeElement":"DecorativeLine_decorativeElement__5Hy53"};